import request from '@/utils/request'

export async function getAgencyOptions() {
  return request({
    url: '/Guide/Agency',
    method: 'post',
  })
}

export async function getRoleOptions(agency) {
  return request({
    url: '/Guide/Role',
    method: 'post',
    data: { agency },
  })
}

export async function getLevelOptions(agency, role) {
  return request({
    url: '/Guide/levelWithoutTop',
    method: 'post',
    data: { agency, role },
  })
}

export async function getTargetLevelOptions(agency, role) {
  return request({
    url: '/Guide/Level',
    method: 'post',
    data: { agency, role },
  })
}
